import { render, staticRenderFns } from "./planet.vue?vue&type=template&id=411537ce&scoped=true"
import script from "./planet.vue?vue&type=script&lang=js"
export * from "./planet.vue?vue&type=script&lang=js"
import style0 from "./planet.vue?vue&type=style&index=0&id=411537ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411537ce",
  null
  
)

export default component.exports